// extracted by mini-css-extract-plugin
export default {"label":"Label_label_Wj1X4 form-label text-truncate","hint":"Label_hint_xHuqt icon cursor-help w-fitc h-fitc"};